import React from 'react';
import {
  Box,
  Typography,
  Paper,
  FormControlLabel,
  Switch,
  Stack,
  Alert
} from '@mui/material';

const NotificationSettings = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Notification Settings
      </Typography>
      <Typography variant="body2" color="text.secondary" paragraph>
        Manage how you receive notifications and updates from the platform.
      </Typography>

      <Alert severity="info" sx={{ mb: 3 }}>
        Notification settings coming soon. These options will allow you to customize email and browser notifications.
      </Alert>

      <Paper sx={{ p: 3, mb: 3, opacity: 0.5 }}>
        <Typography variant="h6" gutterBottom>
          Email Notifications
        </Typography>
        <Stack spacing={2}>
          <FormControlLabel
            control={<Switch checked={true} disabled />}
            label="Enable email notifications"
          />
          <FormControlLabel
            control={<Switch checked={true} disabled />}
            label="Report completion notifications"
          />
          <FormControlLabel
            control={<Switch checked={false} disabled />}
            label="Daily digest emails"
          />
        </Stack>
      </Paper>

      <Paper sx={{ p: 3, mb: 3, opacity: 0.5 }}>
        <Typography variant="h6" gutterBottom>
          Browser Notifications
        </Typography>
        <Stack spacing={2}>
          <FormControlLabel
            control={<Switch checked={true} disabled />}
            label="Enable browser notifications"
          />
          <FormControlLabel
            control={<Switch checked={true} disabled />}
            label="Chat message notifications"
          />
          <FormControlLabel
            control={<Switch checked={false} disabled />}
            label="System update notifications"
          />
        </Stack>
      </Paper>

      <Paper sx={{ p: 3, opacity: 0.5 }}>
        <Typography variant="h6" gutterBottom>
          Activity Alerts
        </Typography>
        <Stack spacing={2}>
          <FormControlLabel
            control={<Switch checked={true} disabled />}
            label="Entity activity alerts"
          />
          <FormControlLabel
            control={<Switch checked={false} disabled />}
            label="Data ingestion completion"
          />
          <FormControlLabel
            control={<Switch checked={false} disabled />}
            label="Token examination results"
          />
        </Stack>
      </Paper>
    </Box>
  );
};

export default NotificationSettings;